import { useCallback } from "react";
import { useAppDispatch } from "../hooks";
import { carouselCrud } from "../slices/carouselSlice";

interface CarouselCrudProps {
  method: string;
  data: any;
  id: number | null;
}

export const useCarouselRequest = () => {
  const dispatch = useAppDispatch();

  const carouselRequest = useCallback(async ({ method, data, id }: CarouselCrudProps): Promise<any> => {
    const dispatchData = await dispatch(carouselCrud({ method, data, id }));
    return dispatchData;
  }, [dispatch]);

  return carouselRequest;
};
